import { render, staticRenderFns } from "./AddAudioButton.vue?vue&type=template&id=7d18af3c&scoped=true&"
import script from "./AddAudioButton.vue?vue&type=script&lang=ts&"
export * from "./AddAudioButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddAudioButton.vue?vue&type=style&index=0&id=7d18af3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d18af3c",
  null
  
)

export default component.exports